import resolveConfig from 'tailwindcss/resolveConfig';

import type { Config } from 'tailwindcss';

const stubConfig: Config = {
    content: [],
    theme: {},
    plugins: [],
};

const resolvedConfig = resolveConfig(stubConfig);

export const colors = resolvedConfig.theme.colors;
